const ChatClientConnectionError = {
  missingChatToken: 'missingChatToken',
  unknown: 'unknown',
};

export default ChatClientConnectionError;
